const MPCI_BASE_URL = `${process.env.REACT_APP_USER_MPCI_URL}/mpcisvc/mpci`

const UaeMpciApiUrls = {
  // Manifest (legacy POC)
  GET: `${MPCI_BASE_URL}/manifest/get`,
  POST: `${MPCI_BASE_URL}/manifest/create`,
  PUT: `${MPCI_BASE_URL}/manifest/update`,
  DELETE: `${MPCI_BASE_URL}/manifest/delete`,
  EXPORT: `${MPCI_BASE_URL}/manifest/download`,
  SUBMIT: `${MPCI_BASE_URL}/manifest/submit`,

  // Master Bill
  MASTER_BILL_LIST: `${MPCI_BASE_URL}/master-bill/list`,
  MASTER_BILL_GET: `${MPCI_BASE_URL}/master-bill/get`,
  MASTER_BILL_POST: `${MPCI_BASE_URL}/master-bill/create`,
  MASTER_BILL_PUT: `${MPCI_BASE_URL}/master-bill/update`,   // append /{id} at call site
    MASTER_BILL_DELETE: `${MPCI_BASE_URL}/master-bill/delete`,       // DELETE /delete/{id} — append id at call site
  MASTER_BILL_SUBMIT: `${MPCI_BASE_URL}/master-bill/submit`, // append /{id} at call site
  MASTER_BILL_CANCEL: `${MPCI_BASE_URL}/master-bill/cancel`,
  MASTER_BILL_CLONE: `${MPCI_BASE_URL}/master-bill/clone`,
  MASTER_BILL_DELETE_MULTIPLE: `${MPCI_BASE_URL}/master-bill/delete-multiple`,
  MASTER_BILL_SUBMIT_MULTIPLE: `${MPCI_BASE_URL}/master-bill/submit-multiple`,

  // House Bill
  HOUSE_BILL_LIST: `${MPCI_BASE_URL}/house-bill/list`,
  HOUSE_BILL_GET: `${MPCI_BASE_URL}/house-bill/get`,
  HOUSE_BILL_POST: `${MPCI_BASE_URL}/house-bill/create`,
  HOUSE_BILL_PUT: `${MPCI_BASE_URL}/house-bill/update`,   // append /{id} at call site
    HOUSE_BILL_DELETE: `${MPCI_BASE_URL}/house-bill/delete`,         // DELETE /delete/{id} — append id at call site
  HOUSE_BILL_SUBMIT: `${MPCI_BASE_URL}/house-bill/submit`, // append /{id} at call site
  HOUSE_BILL_CANCEL: `${MPCI_BASE_URL}/house-bill/cancel`,
  HOUSE_BILL_CLONE: `${MPCI_BASE_URL}/house-bill/clone`,
  HOUSE_BILL_DELETE_MULTIPLE: `${MPCI_BASE_URL}/house-bill/delete-multiple`,
  HOUSE_BILL_SUBMIT_MULTIPLE: `${MPCI_BASE_URL}/house-bill/submit-multiple`,

  // Vessel Master
  VESSEL_MASTER_LIST: `${MPCI_BASE_URL}/vessel-master/list`,
  VESSEL_MASTER_GET: `${MPCI_BASE_URL}/vessel-master/get`,
  VESSEL_MASTER_POST: `${MPCI_BASE_URL}/vessel-master/create`,
  VESSEL_MASTER_PUT: `${MPCI_BASE_URL}/vessel-master/update`,
    VESSEL_MASTER_DELETE: `${MPCI_BASE_URL}/vessel-master/delete`,     // DELETE /delete/{id} — append id at call site
  VESSEL_MASTER_CHECK_IMO: `${MPCI_BASE_URL}/vessel-master/check-imo`,
  VESSEL_MASTER_CLONE: `${MPCI_BASE_URL}/vessel-master/clone`,

  // Party Master
  PARTY_MASTER_LIST: `${MPCI_BASE_URL}/party-master/list`,
  PARTY_MASTER_GET: `${MPCI_BASE_URL}/party-master/get`,
  PARTY_MASTER_POST: `${MPCI_BASE_URL}/party-master/create`,
  PARTY_MASTER_PUT: `${MPCI_BASE_URL}/party-master/update`,
    PARTY_MASTER_DELETE: `${MPCI_BASE_URL}/party-master/delete`,       // DELETE /delete/{id} — append id at call site
  PARTY_MASTER_SEARCH: `${MPCI_BASE_URL}/party-master/search`,
  PARTY_MASTER_CLONE: `${MPCI_BASE_URL}/party-master/clone`,

  // Excel Upload
  EXCEL_UPLOAD_LIST: `${MPCI_BASE_URL}/bill-upload/list`,
  EXCEL_UPLOAD_GET: `${MPCI_BASE_URL}/bill-upload/get`,
  EXCEL_UPLOAD_POST: `${MPCI_BASE_URL}/bill-upload/upload`,
  EXCEL_UPLOAD_TEMPLATE_DOWNLOAD: `${MPCI_BASE_URL}/bill-upload/template/download`,
  EXCEL_UPLOAD_TEMPLATE: `${MPCI_BASE_URL}/bill-upload/template`,
  EXCEL_UPLOAD_REPORT: `${MPCI_BASE_URL}/bill-upload/report`,
  EXCEL_UPLOAD_ERROR_FILE: `${MPCI_BASE_URL}/bill-upload/download-error-file`,
  EXCEL_UPLOAD_SUBMIT_DRAFTS: `${MPCI_BASE_URL}/bill-upload/submit-drafts`,
  EXCEL_UPLOAD_EDIT_DRAFTS: `${MPCI_BASE_URL}/bill-upload/edit-drafts`,
  EXCEL_UPLOAD_DELETE_DRAFTS: `${MPCI_BASE_URL}/bill-upload/delete-drafts`,

    // File Download
  FILE_DOWNLOAD_LIST: `${MPCI_BASE_URL}/file-download/list`,
  FILE_DOWNLOAD_GET:  `${MPCI_BASE_URL}/file-download/download-file`,   // GET /download-file/{id} → binary blob

  // Reports
  REPORT_GENERATE: `${MPCI_BASE_URL}/report/generate`,
  REPORT_COUNT: `${MPCI_BASE_URL}/report/count`,
  REPORT_RETRY: `${MPCI_BASE_URL}/report/retry`,           // POST /retry/{fileDownloadId}
  REPORT_REGENERATE: `${MPCI_BASE_URL}/report/regenerate`,  // POST /regenerate/{fileDownloadId}
  REPORT_REQUEST: `${MPCI_BASE_URL}/report/request`,
  REPORT_REQUESTS_GET: `${MPCI_BASE_URL}/report/requests`,
  REPORT_DOWNLOAD: `${MPCI_BASE_URL}/report/download`,

    // Dashboard
    DASHBOARD_KPI: `${MPCI_BASE_URL}/dashboard/kpi`,
  DASHBOARD_STATUS_COUNTS: `${MPCI_BASE_URL}/dashboard/status-counts`,
  DASHBOARD_ANNOUNCEMENT: `${MPCI_BASE_URL}/dashboard/announcement`,

  // Audit Log
  AUDIT_LOG_GET: `${MPCI_BASE_URL}/audit-log/list`,

    // Version
  VERSION_GET: `${MPCI_BASE_URL}/version/get`,

    // User Settings
  USER_SETTINGS_GET: `${MPCI_BASE_URL}/user-settings/get`,
  USER_SETTINGS_UPDATE: `${MPCI_BASE_URL}/user-settings/update`,

  // App Config
  APP_CONFIG_LIST: `${MPCI_BASE_URL}/app-config/list`,
  APP_CONFIG_GET: `${MPCI_BASE_URL}/app-config/get`,
  APP_CONFIG_CREATE: `${MPCI_BASE_URL}/app-config/create`,
  APP_CONFIG_UPDATE: `${MPCI_BASE_URL}/app-config/update`,
  APP_CONFIG_DELETE: `${MPCI_BASE_URL}/app-config/delete`,

  // Code Maintenance
  CODE_MAINTENANCE_LIST: `${MPCI_BASE_URL}/code-maintenance/list`,
  CODE_MAINTENANCE_GET: `${MPCI_BASE_URL}/code-maintenance/get`,
  CODE_MAINTENANCE_CREATE: `${MPCI_BASE_URL}/code-maintenance/create`,
  CODE_MAINTENANCE_UPDATE: `${MPCI_BASE_URL}/code-maintenance/update`,
  CODE_MAINTENANCE_DELETE: `${MPCI_BASE_URL}/code-maintenance/delete`,
  CODE_MAINTENANCE_CLONE: `${MPCI_BASE_URL}/code-maintenance/clone`,
  CODE_MAINTENANCE_SEARCH: `${MPCI_BASE_URL}/code-maintenance/search`
};

export default UaeMpciApiUrls